import{encodedObjectParser as o}from"@magalu/rave/parser";import{ML2_SID_C as r}from"./cookieConstants.js";const a={[r]:o()};export{a as default};
